import { useCallback, useEffect, useState } from 'react'
import { attributesAPI, type SeoDictionaryItem } from './api'
import type { SeoDictionaryField } from '../pipeline-rules/api'

export type AttributeValues = Partial<Record<SeoDictionaryField, string[]>>

/**
 * Грузит справочник атрибутов один раз и отдаёт значения, сгруппированные по
 * полю (отсортированные по sort). Используется в попапах для выпадающих списков.
 */
export type AttributesLoader = () => Promise<SeoDictionaryItem[]>

export function useAttributes(loader: AttributesLoader = attributesAPI.getAll) {
  const [values, setValues] = useState<AttributeValues>({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const items = await loader()
      const grouped: AttributeValues = {}
      for (const item of items) {
        ;(grouped[item.field] ??= []).push(item.value)
      }
      setValues(grouped)
    } catch (e: any) {
      setError(e?.message || 'Не удалось загрузить атрибуты')
      setValues({})
    } finally {
      setLoading(false)
    }
  }, [loader])

  useEffect(() => {
    void reload()
  }, [reload])

  return { values, loading, error, reload }
}
